import React from 'react';

import { Button } from '@unimed-fesp/components';

const ModalCancelActionFooter = ({ onClick, onClickOk }) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={onClick}
        marginRight={14}
        type="button"
        justifyCenter
        alignCenter
        width={121}
        font="16px unimed_slabregular"
      >
        cancelar
      </Button>
      <Button
        tipo="primary"
        onClick={onClickOk}
        marginLeft={14}
        type="button"
        justifyCenter
        alignCenter
        width={121}
        font="16px unimed_slabregular"
      >
        sim
      </Button>
    </>
  );
};

export default ModalCancelActionFooter;
